/**
 * The number of milliseconds in one minute.
 */
export const MS_PER_MINUTE = 60000;
/**
 * The number of milliseconds in one hour.
 */
export const MS_PER_HOUR = 3600000;
/**
 * The number of milliseconds in one standard day.
 */
export const MS_PER_DAY = 86400000;
